export enum ESolarServiceProvider {
  GOODWE = "GOODWE",
  DEYE = "DEYE",
  VRM = "VRM",
}
